import { MAP_PRESETS } from '../lib/maps';

export function HelpDialog({ onClose }: { onClose: () => void }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h2>How to use this editor</h2>

        <h3>1. Get your mission files</h3>
        <p>
          On Chernarus+ the editor starts with Bohemia's vanilla files already open - only load your own if your
          server's files differ.
        </p>
        <p>
          Console servers are configured through the mission folder on your hosting panel (Nitrado:
          <code> gameserver / dayzxb_missions / {MAP_PRESETS[0].missionFolder} </code> or the PlayStation
          equivalent). Download the files you want to change and drop them onto this page:
        </p>
        <ul>
          <li>
            <code>env/bear_territories.xml</code>, <code>env/wolf_territories.xml</code> and the other
            <code> *_territories.xml</code> files - where animals live.
          </li>
          <li>
            <code>cfgeventspawns.xml</code> - the map positions of every event (loot piles, crashes, vehicles,
            contaminated areas).
          </li>
          <li>
            <code>events.xml</code> - how many of each event exist, and the item group each one carries.
          </li>
          <li>
            <code>types.xml</code> - the loot economy, including the usage / tier tags that decide which parts of
            the map an item group spawns in.
          </li>
          <li>
            <code>cfgplayerspawnpoints.xml</code> - player spawn positions.
          </li>
        </ul>

        <h3>2. Draw</h3>
        <ul>
          <li>Pick a target layer and group in the left panel - new positions go there.</li>
          <li>
            <b>Zone</b> drags a territory circle from its centre. <b>Point</b> drops a single position.
            <b> Scatter</b> paints many at once. <b>Erase</b> paints them away.
          </li>
          <li>
            <b>Select</b> moves things, box-selects with a drag, and resizes a selected zone with the amber
            handle.
          </li>
          <li>Pan with the right mouse button, middle button or space + drag. Zoom with the wheel.</li>
        </ul>

        <h3>3. Export and upload</h3>
        <p>
          Use <b>Export</b> in the header to download the edited XML (one file, or all of them as a zip), then
          upload them back to your server and restart it. Nothing is ever sent anywhere - the editor runs
          entirely in your browser.
        </p>

        <h3>Loot buildings</h3>
        <p>
          On Chernarus+ every lootable building is on the map. Zoom in to see them coloured by tier, and further to
          see each loot spot. Click one to list everything that can spawn there with its chance, and edit the
          types.xml values (nominal, usage, tier, category, tag) right in the list. <b>Where does it spawn?</b>
          lights up every building an item can appear in.
        </p>

        <h3>Map background</h3>
        <p>
          The <b>Map</b> menu above the map switches between Bohemia's official map (bundled, works offline),
          detailed iZurvive / xam.nu tiles (online, calibrated to world metres), your own image (<b>Map image</b> in
          the header) or none.
        </p>

        <h3>On a phone</h3>
        <p>
          Drag to pan, pinch to zoom, tap a building for its loot. The tab bar at the bottom opens layers, loot, the
          editor, the tables and the menu.
        </p>

        <h3>Shortcuts</h3>
        <table className="shortcuts">
          <tbody>
            <tr><td>1 – 6</td><td>select tool</td></tr>
            <tr><td>Ctrl/Cmd + Z</td><td>undo</td></tr>
            <tr><td>Ctrl/Cmd + Shift + Z</td><td>redo</td></tr>
            <tr><td>Delete / Backspace</td><td>delete selection</td></tr>
            <tr><td>F</td><td>fit map to window</td></tr>
            <tr><td>Esc</td><td>clear selection</td></tr>
          </tbody>
        </table>

        <button type="button" className="primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
